import * as React from 'react';
import ImageField from './data-component/data-image';


export interface ContactPreviewProps {
    description: string;
    imageId: string;
}

export interface ContactPreviewState {
}

export default class ContactPreview extends React.Component<ContactPreviewProps, ContactPreviewState> {
  constructor(props: ContactPreviewProps) {
    super(props);

    this.state = {
    }
  }

  public render() {
    return (
      <div className='contact-preview'>
        <div className='contact-container'>
            <div className='image-container'>
                <ImageField id={this.props.imageId} />
            </div>
            <div className='data-container'>
                <p>{this.props.description}</p>
            </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/contact-preview.tsx